import { Link, useLocation } from 'react-router-dom';

const sectionTabs = {
  finance: {
    label: 'Finance',
    tabs: [
      { name: 'Accounts', path: '/finance/master-accounts' },
      { name: 'Cashflow', path: '/finance/cashflow' },
      { name: 'BS Monthly', path: '/finance/balance-sheet-monthly' },
      { name: 'Paycheck', path: '/finance/paycheck' },
      { name: 'Investments', path: '/finance/investments' },
      { name: 'Subscriptions', path: '/finance/subscriptions' },
      { name: 'Taxes', path: '/finance/taxes' },
      { name: 'ME Close', path: '/finance/me-close' },
    ],
  },
  // health: {
  //   label: 'Health',
  //   tabs: [
  //     { name: 'Dashboard', path: '/health/dashboard' },
  //     { name: 'Nutrition', path: '/health/nutrition' },
  //     { name: 'Body Metrics', path: '/health/body-metrics' },
  //     { name: 'Workouts', path: '/health/workouts' },
  //   ],
  // },
  // productivity: {
  //   label: 'Productivity',
  //   tabs: [
  //     { name: 'Habits', path: '/productivity/habits' },
  //     { name: 'Planner', path: '/productivity/planner' },
  //     { name: 'Tasks', path: '/productivity/tasks' },
  //   ],
  // },
  // life: {
  //   label: 'Goals',
  //   tabs: [
  //     { name: 'Bucket List', path: '/life/bucket-list' },
  //     { name: 'Reading List', path: '/life/reading' },
  //     { name: 'Places', path: '/life/places' },
  //   ],
  // },
};

export default function TopBar() {
  const { pathname } = useLocation();

  const getActiveSection = () => {
    if (pathname.startsWith('/finance')) return 'finance';
    if (pathname.startsWith('/health')) return 'health';
    if (pathname.startsWith('/productivity')) return 'productivity';
    if (pathname.startsWith('/life')) return 'life';
    return null;
  };

  const activeSection = getActiveSection();
  const section = activeSection ? sectionTabs[activeSection] : null;

  if (!section) return null;

  return (
    <div className="flex items-center h-12 px-4 md:px-6 lg:px-8 border-b border-border/50 bg-bg-secondary/50 shrink-0 overflow-x-auto scrollbar-hide">
      <span className="text-xs font-semibold uppercase tracking-wider text-text-muted shrink-0" style={{ marginRight: '2rem' }}>
        {section.label}
      </span>
      <nav className="flex items-center gap-2">
        {section.tabs.map((tab) => {
          const active = pathname === tab.path;
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`px-3 py-1.5 md:px-4 md:py-2 text-xs rounded-lg transition-all duration-150 whitespace-nowrap ${
                active
                  ? 'text-accent bg-accent/10 font-medium'
                  : 'text-text-secondary hover:text-text-primary hover:bg-bg-tertiary/40'
              }`}
            >
              {tab.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
